export class Occupation {
	public since: string
	public occupation: number

	constructor(data: { since: string; occupation: number }) {
		this.since = data.since
		this.occupation = data.occupation
	}

	static create(data: Partial<Occupation>): Occupation {
		const defaultData: Occupation = {
			since: '',
			occupation: 0,
		}

		return new Occupation({
			...defaultData,
			...data,
		})
	}
}
